import React, { memo } from 'react';
import { Tooltip, Typography, Chip, Divider, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../DiagnosticRevisionTable.style';
import { diagnosticsClassColor } from '../../../../../../helpers/manageColors';
import { sizeChangeTooltip, sizeChangeIcon } from '../utils/utils';

const SizeCell = ({ isExpanded, nested, lesionAllInfo, projection }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  // Extract data from lesionAllInfo

  const matched = lesionAllInfo?.matched || lesionAllInfo?.match;
  const matchedLesions = lesionAllInfo?.matched_lesions;
  const matchedLesionAllInfo = matchedLesions?.[1] || matchedLesions?.[0];

  const sizeChangeStart = lesionAllInfo?.size_change_first || matchedLesionAllInfo?.size_change_first;
  const sizeChangeLatest = lesionAllInfo?.size_change_latest || matchedLesionAllInfo?.size_change_latest;
  const growthCategoryStart =
    lesionAllInfo?.growth_category_first || matchedLesionAllInfo?.growth_category_first;
  const growthCategoryLatest =
    lesionAllInfo?.growth_category_latest || matchedLesionAllInfo?.growth_category_latest;

  if (isExpanded && !nested) {
    return <div className={classes.empty_cell_container} />;
  }

  if (nested && !lesionAllInfo?.size) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90%',
      }}>
      <Tooltip
        arrow
        title={
          sizeChangeStart || sizeChangeLatest ? (
            <>
              <Typography className={classes.tooltip_text}>
                {sizeChangeTooltip(
                  'first',
                  sizeChangeStart,
                  lesionAllInfo?.date_first || matchedLesionAllInfo?.date_first,
                  t
                )}
              </Typography>

              {sizeChangeStart && sizeChangeLatest && <Divider style={{ margin: '4px 0' }} />}

              <Typography className={classes.tooltip_text}>
                {sizeChangeTooltip(
                  'latest',
                  sizeChangeLatest,
                  lesionAllInfo?.date_latest || matchedLesionAllInfo?.date_latest,
                  t
                )}
              </Typography>
            </>
          ) : matchedLesions && matchedLesions.length > 0 ? (
            matchedLesions.map((matched_lesion, idx) => (
              <Typography key={idx} className={classes.tooltip_text}>
                {`${
                  matched_lesion?.unique_position?.[0]?.toUpperCase() ||
                  matched_lesion?.projection?.toUpperCase()
                }: ${matched_lesion?.size?.[0]?.toFixed(1)} x ${matched_lesion?.size?.[1]?.toFixed(1)} mm`}
              </Typography>
            ))
          ) : (
            <Typography className={classes.tooltip_text}>
              {lesionAllInfo?.size
                ? `${projection?.toUpperCase() || ''} : ${lesionAllInfo?.size?.[0]?.toFixed(
                    0
                  )} x ${lesionAllInfo?.size?.[1]?.toFixed(1)} mm`
                : 'N/A'}
            </Typography>
          )
        }>
        <Chip
          label={
            <div className={classes.size_chip_container}>
              <Typography style={{ fontSize: '12px' }}>
                {lesionAllInfo?.isMatchedMainRow
                  ? lesionAllInfo?.matched_size
                  : lesionAllInfo?.size
                  ? `${lesionAllInfo?.size?.[0]?.toFixed(1)} x ${lesionAllInfo?.size?.[1]?.toFixed(1)} mm`
                  : '—'}
              </Typography>

              {(sizeChangeStart || sizeChangeLatest) && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px',
                    marginLeft: '4px',
                  }}>
                  {sizeChangeStart && sizeChangeIcon(sizeChangeStart, growthCategoryStart, classes)}
                  {sizeChangeLatest && sizeChangeIcon(sizeChangeLatest, growthCategoryLatest, classes)}
                </div>
              )}
            </div>
          }
          size='small'
          className={classes.size_chip}
          style={{
            background:
              `${diagnosticsClassColor(growthCategoryLatest, theme)}90` ||
              `${diagnosticsClassColor(growthCategoryStart, theme)}90`,
          }}
        />
      </Tooltip>
    </div>
  );
};

export default memo(SizeCell);
